<template>
  <b-card no-body header="PM₂.₅颗粒物分析" class="mt-4" style="font-size:1rem;">
    <b-list-group flush>
      <b-list-group-item :active="name=='menu1'" to="/chemical_components">
        <!-- <i class="fa fa-area-chart" aria-hidden="true"></i> -->
        PM₂.₅化学组分
      </b-list-group-item>
      <b-list-group-item :active="name=='menu2'" to="/chemical_rate">化学组分占比</b-list-group-item>
      <b-list-group-item :active="name=='sor'" to="/sor">硫氮氧化速率</b-list-group-item>
      <b-list-group-item href="#">硫碳分析</b-list-group-item>
      <b-list-group-item href="#">氮碳分析</b-list-group-item>
      <b-list-group-item href="#">含碳组分分析</b-list-group-item>
      <b-list-group-item href="#">PM₂.₅解析结果</b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: "PmLeftMenu",
  props: {
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>

